<header
    class="fixed top-0 right-0 left-0 z-40 flex w-full flex-col transition-all duration-500 ease-in-out"
    [ngClass]="isScrolled() ? 'mx-auto max-w-[96rem]' : ''"
>
    <div
        class="transition-all duration-500 ease-in-out"
        [ngClass]="isScrolled() ? 'mt-2' : ''"
    >
        <div
            class="flex h-16 w-full items-center transition-all duration-500 ease-in-out"
            [class.rounded-2xl]="isScrolled()"
            [class.shadow-lg]="isScrolled()"
            [class.px-4]="isScrolled()"
            [class.py-2]="isScrolled()"
            [class.border]="isScrolled()"
            [class.border-transparent]="!isScrolled()"
            [class.border-slate-200]="isScrolled()"
            [style.background-color]="isScrolled() ? '#ffffff' : 'transparent'"
        >
            <div
                class="mx-auto flex h-full w-full max-w-[96rem] items-center justify-between"
            >
                <div class="flex h-full shrink-0 items-center gap-3">
                    <button
                        class="flex h-9 w-9 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100 md:hidden"
                        (click)="toggleMobileMenu()"
                    >
                        @if (isMobileMenuOpen()) {
                            <ng-icon name="lucideX" class="h-5 w-5" />
                        } @else {
                            <ng-icon name="lucideMenu" class="h-5 w-5" />
                        }
                    </button>
                    <a href="/" class="flex items-center gap-2">
                        <img
                            src="assets/images/cjc.svg"
                            alt="CJC Public"
                            class="h-9 w-auto object-contain md:h-12"
                        />
                    </a>
                </div>

                <nav
                    class="hidden flex-1 items-center justify-center gap-6 md:flex"
                >
                    <a
                        href="/categories"
                        class="flex items-center gap-1.5 text-base font-medium transition-colors hover:text-[#1587e8]"
                        style="font-family: var(--font-primary); color: #0f172a"
                        (mouseenter)="onHoverEnter('categories')"
                        (mouseleave)="onHoverLeave()"
                    >
                        <ng-icon name="lucideLayoutGrid" class="h-5 w-5" />
                        <span>All Categories</span>
                        <ng-icon name="lucideChevronDown" class="h-3.5 w-3.5" />
                    </a>
                    <a
                        href="/brands"
                        class="flex items-center gap-1.5 text-base font-medium transition-colors hover:text-[#1587e8]"
                        style="font-family: var(--font-primary); color: #0f172a"
                        (mouseenter)="onHoverEnter('brands')"
                        (mouseleave)="onHoverLeave()"
                    >
                        <ng-icon name="lucideBuilding2" class="h-5 w-5" />
                        <span>Shop by Brands</span>
                        <ng-icon name="lucideChevronDown" class="h-3.5 w-3.5" />
                    </a>
                    <a
                        href="/vouchers"
                        class="flex items-center gap-1.5 text-base font-medium transition-colors hover:text-[#1587e8]"
                        style="font-family: var(--font-primary); color: #0f172a"
                        (mouseenter)="onHoverEnter('vouchers')"
                        (mouseleave)="onHoverLeave()"
                    >
                        <ng-icon name="lucideTicket" class="h-5 w-5" />
                        <span>Gift Vouchers</span>
                        <ng-icon name="lucideChevronDown" class="h-3.5 w-3.5" />
                    </a>
                    <a
                        routerLink="/raffle"
                        class="flex items-center gap-1.5 text-base font-medium transition-colors hover:text-[#1587e8]"
                        style="font-family: var(--font-primary); color: #0f172a"
                    >
                        <ng-icon
                            name="lucideTrophy"
                            class="h-5 w-5 text-amber-500"
                        />
                        <span>Raffles</span>
                    </a>
                </nav>

                <div class="flex shrink-0 items-center gap-2">
                    <app-header-profile-menu
                        [userName]="userName()"
                        [userRole]="userRole()"
                        [userEmail]="userEmail()"
                    />
                </div>
            </div>
        </div>
    </div>

    <div
        class="nav-drawer z-50 mx-auto max-w-7xl rounded-b-xl shadow-xl"
        style="background-color: #ffffff; color: #0f172a"
        [class.show]="hoveredItem() !== null"
        (mouseenter)="onDrawerEnter()"
        (mouseleave)="onDrawerLeave()"
    >
        @if (hoveredItem() === 'categories') {
            <div class="flex min-h-[300px]" (mouseleave)="onCategoryLeave()">
                <div class="w-64 border-r border-slate-100 py-2">
                    @for (category of categories; track category.name) {
                        <a
                            href="#"
                            class="flex items-center gap-3 px-4 py-2 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                            [class.bg-blue-50]="
                                hoveredCategory() === category.name
                            "
                            [class.text-[#1587e8]]="
                                hoveredCategory() === category.name
                            "
                            (mouseenter)="onCategoryEnter(category.name)"
                            (click)="navigateToCategory(category.slug, $event)"
                        >
                            <div
                                class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                            >
                                <img
                                    [src]="category.icon"
                                    [alt]="category.name"
                                    class="h-5 w-5 object-contain"
                                />
                            </div>
                            <span class="text-sm font-medium">{{
                                category.name
                            }}</span>
                            <ng-icon
                                name="lucideChevronRight"
                                class="ml-auto h-4 w-4 text-slate-400"
                            />
                        </a>
                    }
                </div>
                <div class="flex-1 p-6">
                    @if (hoveredCategory()) {
                        @for (category of categories; track category.name) {
                            @if (category.name === hoveredCategory()) {
                                <div>
                                    <h3
                                        class="mb-3 text-sm font-semibold text-[#0f172a]"
                                    >
                                        {{ category.name }}
                                    </h3>
                                    <div class="grid grid-cols-3 gap-3">
                                        @for (
                                            sub of category.subcategories;
                                            track sub.name
                                        ) {
                                            <a
                                                href="#"
                                                class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                            >
                                                <div
                                                    class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                                                >
                                                    <img
                                                        [src]="sub.icon"
                                                        [alt]="sub.name"
                                                        class="h-5 w-5 object-contain"
                                                    />
                                                </div>
                                                <span
                                                    class="text-sm font-medium"
                                                    >{{ sub.name }}</span
                                                >
                                            </a>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    } @else {
                        <div
                            class="flex h-full items-center justify-center text-sm text-slate-400"
                        >
                            Hover over a category to see subcategories
                        </div>
                    }
                </div>
            </div>
        }

        @if (hoveredItem() === 'brands') {
            <div class="grid grid-cols-3 gap-3 p-5">
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideShoppingBag"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Nike</span>
                </a>
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideSmartphone"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Apple</span>
                </a>
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideMonitor"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Samsung</span>
                </a>
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideHeadphones"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Sony</span>
                </a>
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideFootprints"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Adidas</span>
                </a>
                <a
                    href="#"
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideShirt"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <span class="text-sm font-medium">Puma</span>
                </a>
            </div>
        }

        @if (hoveredItem() === 'vouchers') {
            <div class="grid grid-cols-2 gap-3 p-5">
                <div
                    class="flex items-center gap-3 rounded-lg border border-dashed border-blue-200 bg-blue-50/50 px-3 py-2.5 transition-colors hover:bg-blue-50"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideTicket"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <div class="flex flex-col">
                        <span class="text-sm font-semibold text-[#0f172a]"
                            >SAVE20</span
                        >
                        <span class="text-xs text-blue-600">20% Off</span>
                    </div>
                </div>
                <div
                    class="flex items-center gap-3 rounded-lg border border-dashed border-blue-200 bg-blue-50/50 px-3 py-2.5 transition-colors hover:bg-blue-50"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideTicket"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <div class="flex flex-col">
                        <span class="text-sm font-semibold text-[#0f172a]"
                            >FLAT50</span
                        >
                        <span class="text-xs text-blue-600">Flat ৳50 Off</span>
                    </div>
                </div>
                <div
                    class="flex items-center gap-3 rounded-lg border border-dashed border-blue-200 bg-blue-50/50 px-3 py-2.5 transition-colors hover:bg-blue-50"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideTicket"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <div class="flex flex-col">
                        <span class="text-sm font-semibold text-[#0f172a]"
                            >FREESHIP</span
                        >
                        <span class="text-xs text-blue-600">Free Shipping</span>
                    </div>
                </div>
                <div
                    class="flex items-center gap-3 rounded-lg border border-dashed border-blue-200 bg-blue-50/50 px-3 py-2.5 transition-colors hover:bg-blue-50"
                >
                    <div
                        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-blue-100"
                    >
                        <ng-icon
                            name="lucideTicket"
                            class="h-4 w-4 text-blue-600"
                        />
                    </div>
                    <div class="flex flex-col">
                        <span class="text-sm font-semibold text-[#0f172a]"
                            >BONUS10</span
                        >
                        <span class="text-xs text-blue-600">Extra 10% Off</span>
                    </div>
                </div>
            </div>
        }
    </div>

    @if (isMobileMenuOpen()) {
        <div
            class="fixed inset-0 top-16 z-50 md:hidden"
            style="background-color: rgba(0, 0, 0, 0.4)"
            (click)="closeMobileMenu()"
        >
            <div
                class="h-full overflow-y-auto bg-white"
                (click)="$event.stopPropagation()"
            >
                <div class="p-4">
                    <div class="mb-6">
                        <h3
                            class="mb-3 text-xs font-bold tracking-wider text-slate-800 uppercase"
                        >
                            Categories
                        </h3>
                        <ul class="space-y-1">
                            @for (category of categories; track category.name) {
                                <li>
                                    <button
                                        class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                        (click)="
                                            navigateToCategoryMobile(
                                                category.slug
                                            )
                                        "
                                    >
                                        <div
                                            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-rose-100"
                                        >
                                            <img
                                                [src]="category.icon"
                                                [alt]="category.name"
                                                class="h-5 w-5 object-contain"
                                            />
                                        </div>
                                        <span class="text-sm font-medium">{{
                                            category.name
                                        }}</span>
                                        <ng-icon
                                            name="lucideChevronRight"
                                            class="ml-auto h-4 w-4 text-slate-400"
                                        />
                                    </button>
                                </li>
                            }
                        </ul>
                    </div>

                    <div class="mb-4 border-t border-slate-200 pt-4">
                        <h3
                            class="mb-3 text-xs font-bold tracking-wider text-slate-800 uppercase"
                        >
                            Quick Links
                        </h3>
                        <ul class="space-y-1">
                            @if (showClientDashboard()) {
                                <li>
                                    <a
                                        routerLink="/client/dashboard"
                                        (click)="closeMobileMenu()"
                                        class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                    >
                                        <ng-icon
                                            name="lucideLayoutDashboard"
                                            class="h-5 w-5 text-sky-600"
                                        />
                                        <span class="text-sm font-medium"
                                            >Dashboard</span
                                        >
                                    </a>
                                </li>
                            }
                            <li>
                                <a
                                    routerLink="/raffle"
                                    (click)="closeMobileMenu()"
                                    class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                >
                                    <ng-icon
                                        name="lucideTrophy"
                                        class="h-5 w-5 text-amber-500"
                                    />
                                    <span class="text-sm font-medium"
                                        >Raffles</span
                                    >
                                </a>
                            </li>
                            <li>
                                <button
                                    class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                    (click)="navigateToClaimedItemsMobile()"
                                >
                                    <ng-icon
                                        name="lucideShoppingCart"
                                        class="h-5 w-5"
                                    />
                                    <span class="text-sm font-medium"
                                        >My Items</span
                                    >
                                </button>
                            </li>
                            <li>
                                <a
                                    routerLink="/client/profile"
                                    (click)="closeMobileMenu()"
                                    class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-slate-700 transition-colors hover:bg-blue-50 hover:text-[#1587e8]"
                                >
                                    <ng-icon
                                        name="lucideUser"
                                        class="h-5 w-5"
                                    />
                                    <span class="text-sm font-medium"
                                        >My Profile</span
                                    >
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="border-t border-slate-200 pt-4">
                        @if (isLoggedIn()) {
                            <div class="mb-3 flex items-center gap-3 px-3">
                                <div
                                    class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#1587e8] text-sm font-semibold text-white shadow-sm"
                                >
                                    {{ displayInitials() }}
                                </div>
                                <div class="flex flex-col">
                                    <span
                                        class="text-sm font-semibold text-slate-800"
                                        >{{ displayName() }}</span
                                    >
                                    <span
                                        class="text-xs text-slate-500 capitalize"
                                        >{{ displayRole() }}</span
                                    >
                                </div>
                            </div>
                            <button
                                (click)="logout()"
                                class="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-red-600 transition-colors hover:bg-red-50"
                            >
                                <ng-icon name="lucideLogOut" class="h-5 w-5" />
                                <span class="text-sm font-medium">Log Out</span>
                            </button>
                        } @else {
                            <a
                                routerLink="/login"
                                (click)="closeMobileMenu()"
                                class="flex w-full items-center justify-center gap-2 rounded-lg bg-[#1587e8] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1172c7]"
                            >
                                <ng-icon name="lucideUser" class="h-4 w-4" />
                                <span>Sign In</span>
                            </a>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</header>
